import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import App from "../../App.js";
import ProductDetail from "../sections/ProductDetail";
import ProductDetailV2 from "../sections/ProductDetailV2";

const PageRoutes = (props) => {
    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route path="" element={<App />} />
                    <Route path="product-detail" element={<ProductDetailV2 />} />
                    <Route path="product-detailV2" element={<ProductDetailV2 />} />
                </Routes>
            </BrowserRouter>
        </>
    );
};

export default PageRoutes; 
